import styled from "styled-components";

export const Container= styled.div`
width:80%;
padding:0rem 10rem;
`